// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"215f66e6","106":"30e6ff04","406":"f23ac4cb","423":"6d7f2613"}[chunkId] + ".css";
};